import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

const beeRidgeConfig = {
  pageTitle:       'Bee Ridge Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Bee Ridge, FL. Sam\'s Tree Service handles hazardous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_bee_ridge',

  heroHeading: 'Serving Bee Ridge',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  sectionHeading: 'Professional Tree Service in Bee Ridge Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the residential and commercial 
     properties of <strong>Bee Ridge</strong> with reliable, expert tree care. Overgrown 
     trees pushing against homes, storm weakened branches hanging over driveways, and 
     palms crowding power lines are all jobs our team handles with precision and care, 
     the kind of work other companies turn away.`,

    `We specialize in <strong>hazardous tree removal and trimming</strong>, including 
     diseased or structurally compromised trees, heavy limbs threatening structures, and 
     overgrown canopies blocking light and creating storm risk. Every service is tailored 
     to your property's specific needs and Florida's year round weather demands.`,

    `<strong>Sam's Tree Service</strong> delivers dependable, affordable tree care across 
     <strong>Bee Ridge</strong> and throughout <strong>Sarasota County</strong>,
     so your property stays protected and your trees stay healthy through every season.`,
  ],

  ctaLabel: 'Get a Free Estimate!',
  mapCity: 'Bee Ridge, FL',
};

const Services_BeeRidge = () => <LocationPage config={beeRidgeConfig} />;
export default Services_BeeRidge;
